import { render, staticRenderFns } from "./ProductHeader.vue?vue&type=template&id=f6daebb2&"
import script from "./ProductHeader.vue?vue&type=script&lang=ts&"
export * from "./ProductHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ProductHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports